import React, { lazy, Suspense, useEffect } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useCartContext } from "../context/CartContext";
import { IoIosArrowBack } from "../utils/Icons";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

// Imports
const CartComponentCard = lazy(() => import("./CartComponentCard"));

const CartComponent = () => {
  const { deviceOS } = useAuthContext();
  const { setIsCart, cartData, cartTotal, getCart } = useCartContext();
  const navigate = useNavigate();

  const handleShopNowClick = () => {
    setIsCart(false);
    navigate("/");
  };

  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");
    // console.log("token", token);
    // console.log("userId", userId);
    if (token && userId) {
      getCart();
    }
  }, [getCart]);

  return (
    <div className="w-screen h-screen bg-black/50 flex flex-col lg:flex-row justify-between items-center fixed left-0 top-0 right-0 bottom-0 z-50">
      <div
        className="w-full lg:w-2/3 h-1/3 lg:h-full"
        onClick={() => setIsCart(false)}
      ></div>
      <div
        className={`w-full lg:w-1/3 h-2/3  lg:h-full bg-whiteColor border rounded-2xl lg:rounded-none shadow ${
          deviceOS === "ios" ? "pb-[5%]" : "pb-[3%]"
        } lg:pb-0 animate-slideBottomToTop lg:animate-slideRightToLeft`}
      >
        <div className="w-full h-fit border-b p-[3.5%]">
          <button
            className="flex items-center text-textPrimaryColor space-x-1"
            onClick={() => setIsCart(false)}
          >
            <IoIosArrowBack className="text-2xl" />
            <span className="font-normal text-[3.5vw] lg:text-[0.9vw]">
              Back
            </span>
          </button>
        </div>
        {cartData?.items?.length > 0 ? (
          <div className="w-full h-[93.5%] flex flex-col justify-between items-center py-[3%]">
            <div className="w-full h-[85%] px-[5%] space-y-[3%] pb-[3%] overflow-x-hidden overflow-y-scroll">
              <Suspense
                fallback={
                  <div className="w-full h-full flex justify-center items-center">
                    <p className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor">
                      Loading...
                    </p>
                  </div>
                }
              >
                {cartData?.items?.map((item, index) => (
                  <CartComponentCard data={item} key={index} />
                ))}
              </Suspense>
            </div>
            <div className="w-full h-fit flex justify-between items-center border-t p-[5%]">
              <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                Total :{" "}
                <span className="font-semibold text-primaryColor">
                  {cartTotal}
                </span>
              </span>
              <button
                className="bg-primaryColor font-normal text-[3.5vw] lg:text-[0.9vw] text-whiteColor rounded-3xl shadow px-[25%] py-3"
                onClick={() => navigate("/cart")}
              >
                Proceed
              </button>
            </div>
          </div>
        ) : (
          <div className="w-full h-full flex flex-col justify-center items-center space-y-6">
            <p className="font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor">
              Looks like your cart is empty
            </p>
            <button
              className="bg-primaryColor font-normal text-[3.5vw] lg:text-[0.9vw] text-whiteColor rounded-xl shadow px-4 py-2"
              onClick={handleShopNowClick} 
            >
              Shop Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartComponent;
